export function formatDeliveryMonths(months: number[]): string {
  if (months.length === 0) return ""

  const sorted = [...months].sort((a, b) => a - b)

  // Group into consecutive runs
  const runs: number[][] = []
  let current: number[] = [sorted[0]]
  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i] === sorted[i - 1] + 1) {
      current.push(sorted[i])
    } else {
      runs.push(current)
      current = [sorted[i]]
    }
  }
  runs.push(current)

  return runs
    .map((run) =>
      run.length === 1 ? `${run[0]}月` : `${run[0]}月下旬〜${run[run.length - 1]}月上旬`
    )
    .join("・")
}
